module.exports = __webpack_public_path__ + "img/vertical_6_3_3016.23af6a5f.png";